export default __webpack_public_path__ + "6e487e420b6d09fa9d9020b7180c1f53.png";